mainApp.component('qualityThresholds', {
    templateUrl: '/public/components/configuration/failover/quality-thresholds.component.html',
    bindings: {
        config: "<?",
        onConfigChanged: "&?",
        path: "<?",
        defaults: "<",
        defaultLabel: "<",
    },
    controller: function($scope, $controller) {
        const ctrl = this;
        _.merge(ctrl, $controller('BaseFailoverConfigController', {$scope: $scope, ctrl: ctrl,}));

        ctrl.updateDefaultsLabel = function() {
            if(!ctrl.labels) {
                ctrl.labels = {};
            }
            ctrl.labels.packetLoss = ctrl.defaultLabel + "(" + ctrl.defaults.packetLoss + "%)";
            ctrl.labels.jitter = ctrl.defaultLabel + "(" + ctrl.defaults.jitter + " ms)";
            ctrl.labels.latency = ctrl.defaultLabel + "(" + ctrl.defaults.latency + " ms)";
        }

    }
});